import {
    ADD_APPOINTMENT_LINK,
    ADD_EDIT_APPT_NOTE,
    APPEND_SIGNATURE_TO_APPMT,
    BULK_ASSIGN_SIGNATURE,
    APPOINTMENT_FROM_TEMPLATE,
    APPOINTMENT_REPEAT,
    CANCEL_APPT,
    CHANGE_APPOINTMENT_LOCK_UNLOCK,
    CHANGE_APPT_UNITS,
    CHANGE_CANCEL_REASON,
    CONNECT_RECONNECT_TEMPLATE,
    CREATE_APPOINTMENT,
    DELETE_ALL_APPT,
    DELETE_APPOINTMENT,
    DELETE_APPT_DOCUMENT,
    DELETE_APPT_NOTE,
    DELETE_SIGNATURE,
    EDIT_APPOINTMENT,
    EDIT_APPOINTMENT_POSITION,
    EDIT_APPT_DOCUMENT,
    GET_APPOINTMENT,
    GET_APPOINTMENT_BY_FILTERS,
    GET_APPOINTMENT_BY_ID,
    GET_APPOINTMENT_DATES_BY_ID,
    GET_APPOINTMENT_INFORMATION,
    GET_APPT_ADDRESSES,
    REMOVE_APPT_ADDRESSES,
    GET_ELIGIBLE_CHARGE_RATES,
    REMOVE_ELIGIBLE_CHARGE_RATES,
    GET_APPT_DOCUMENT,
    GET_APPT_STAFFS,
    GET_CLIENT_STAFFS,
    MANAGE_NOTES,
    REFRESH_ERRORS,
    REMOVE_APPOINTMENT_BY_ID,
    REMOVE_APPOINTMENT_DATES_BY_ID,
    REMOVE_APPT_FROM_BILL,
    REMOVE_APPT_FROM_INVOICE,
    REMOVE_CLIENT_STAFFS,
    SAVE_CURRENT_LOCATION,
    SET_APPOINTMENT_STATUS,
    UN_RENDER_APPT,
    UPLOAD_APPT_DOCUMENT,
    DELETE_MASS_APPTS,
    REMOVE_APPOINTMENT_INFORMATION,
    REQUEST_APPT_NOTE,
    REMIND_APPT_NOTE,
    COMPLETE_MASS_APPTS,
    CHECK_ELIGIBILITY,
    UN_CANCEL_APPT,
    GET_APPT_DATA_COLLECTION,
    GET_APPOINTMENT_FOR_CALENDAR,
    REMIND_APPT_SIGNATURE,
} from './appointment.type';

/** Create, Edit Appointment */

export const createAppointment = (body) => {
    return {
        type: CREATE_APPOINTMENT,
        payload: { body },
    };
};

export const editAppointment = (body, id) => {
    return {
        type: EDIT_APPOINTMENT,
        payload: { body, id },
    };
};
export const addApptLink = (body, id) => {
    return {
        type: ADD_APPOINTMENT_LINK,
        payload: { body, id },
    };
};

export const editAppointmentPosition = (body, id) => {
    return {
        type: EDIT_APPOINTMENT_POSITION,
        payload: { body, id },
    };
};

export const changeApptLockUnlock = (list, type, params, apptId) => {
    return {
        type: CHANGE_APPOINTMENT_LOCK_UNLOCK,
        payload: { list, type, params, apptId },
    };
};

export const changeApptUnits = (apptId, type) => {
    return {
        type: CHANGE_APPT_UNITS,
        payload: { apptId, type },
    };
};

/** end */

/** Get Appointment */

export const getAppointment = (params, load) => {
    return {
        type: GET_APPOINTMENT,
        payload: { params, load },
    };
};
export const getCalendarAppointment = (params, load) => {
    return {
        type: GET_APPOINTMENT_FOR_CALENDAR,
        payload: { params, load },
    };
};

export const getAppointmentById = (id) => {
    return {
        type: GET_APPOINTMENT_BY_ID,
        payload: { id },
    };
};

export const getAppointmentDates = (id) => {
    return {
        type: GET_APPOINTMENT_DATES_BY_ID,
        payload: { id },
    };
};
export const removeAppointmentDates = () => {
    return {
        type: REMOVE_APPOINTMENT_DATES_BY_ID,
    };
};
export const removeAppointmentById = () => {
    return {
        type: REMOVE_APPOINTMENT_BY_ID,
    };
};
export const getAppointmentInfo = (id) => {
    return {
        type: GET_APPOINTMENT_INFORMATION,
        payload: { id },
    };
};

/** Load appointment location addresses (client + client contact + staff + office). */
export const getApptAddresses = (clientId, staffId) => {
    return {
        type: GET_APPT_ADDRESSES,
        payload: { clientId, staffId },
    };
};

/** Clear the loaded appointment addresses (e.g. on modal close) so they don't leak to the next appt. */
export const removeApptAddresses = () => {
    return {
        type: REMOVE_APPT_ADDRESSES,
    };
};

/**
 * Load the charge rates on the authorized service that the given staff qualifies for. Needs all
 * three of client + service + staff — eligibility depends on the staff's credentials, the rates
 * attached to the authorization, and the client's allowed-staff list.
 */
export const getEligibleChargeRates = (staffId, authServiceId, clientId) => {
    return {
        type: GET_ELIGIBLE_CHARGE_RATES,
        payload: { staffId, authServiceId, clientId },
    };
};

/** Clear the eligible charge rates (client/service/staff changed, or modal closed). */
export const removeEligibleChargeRates = () => {
    return {
        type: REMOVE_ELIGIBLE_CHARGE_RATES,
    };
};
export const removeAppointmentInfo = () => {
    return {
        type: REMOVE_APPOINTMENT_INFORMATION,
    };
};

export const getAppointmentByFilters = (params, load) => {
    return {
        type: GET_APPOINTMENT_BY_FILTERS,
        payload: { params, load },
    };
};

export const getApptDataCollection = (sessionId) => {
    return {
        type: GET_APPT_DATA_COLLECTION,
        payload: { sessionId },
    };
};
/** end */

/** Delete Appointment */

export const deleteAppointment = (id) => {
    return {
        type: DELETE_APPOINTMENT,
        payload: { id },
    };
};
export const deleteMassAppt = (apptList, params) => {
    return {
        type: DELETE_MASS_APPTS,
        payload: { apptList, params },
    };
};

/** end */

/** Appointment Status */

export const setAppointmentStatus = (id, statusName, reason) => {
    return {
        type: SET_APPOINTMENT_STATUS,
        payload: { id, statusName, reason },
    };
};

export const removeApptFromBill = (id, params) => {
    return {
        type: REMOVE_APPT_FROM_BILL,
        payload: { id, params },
    };
};

export const removeApptFromInvoice = (id, params) => {
    return {
        type: REMOVE_APPT_FROM_INVOICE,
        payload: { id, params },
    };
};

export const editCancelReason = (id, reason) => {
    return {
        type: CHANGE_CANCEL_REASON,
        payload: { id, reason },
    };
};

export const unRenderAppt = (id) => {
    return {
        type: UN_RENDER_APPT,
        payload: { id },
    };
};

export const completeMassAppts = (apptIds, params) => {
    return {
        type: COMPLETE_MASS_APPTS,
        payload: { apptIds, params },
    };
};

/** end */

/** Appointment Repeat */

export const appointmentRepeat = (body) => {
    return {
        type: APPOINTMENT_REPEAT,
        payload: { body },
    };
};
export const appointmentFromTemplate = (body) => {
    return {
        type: APPOINTMENT_FROM_TEMPLATE,
        payload: { body },
    };
};
/** end */

export const appendSignatureToAppmt = (id, signature, type) => {
    return {
        type: APPEND_SIGNATURE_TO_APPMT,
        payload: { id, signature, type },
    };
};

export const bulkAssignSignature = (body) => {
    return {
        type: BULK_ASSIGN_SIGNATURE,
        payload: { body },
        // payload: { apptIds, file, signatureLocation },
    };
};

export const deleteSignature = (apptId, type) => {
    return {
        type: DELETE_SIGNATURE,
        payload: { apptId, type },
    };
};

export const saveCurrentLocation = (pos) => {
    return {
        type: SAVE_CURRENT_LOCATION,
        payload: pos,
    };
};

export const getStaffClients = (clientId, authServiceId) => {
    return {
        type: GET_CLIENT_STAFFS,
        payload: { clientId, authServiceId },
    };
};

export const removeStaffClients = (c) => {
    return {
        type: REMOVE_CLIENT_STAFFS,
    };
};

export const manageNotes = (id, params) => {
    return {
        type: MANAGE_NOTES,
        payload: { id, params },
    };
};

export const connectReconnect = (id, params) => {
    return {
        type: CONNECT_RECONNECT_TEMPLATE,
        payload: { id, params },
    };
};
export const cancelAppt = (id, params) => {
    return {
        type: CANCEL_APPT,
        payload: { id, params },
    };
};
export const unCancelAppt = (id) => {
    return {
        type: UN_CANCEL_APPT,
        payload: { id },
    };
};
export const deleteAllAppt = (id, params) => {
    return {
        type: DELETE_ALL_APPT,
        payload: { id, params },
    };
};

export const getApptStaffs = () => {
    return {
        type: GET_APPT_STAFFS,
    };
};

/** Appt Documents */

export const uploadApptDocument = (file, id) => {
    return {
        type: UPLOAD_APPT_DOCUMENT,
        payload: { file, id },
    };
};

export const editApptDocument = (id, dockId, file) => {
    return {
        type: EDIT_APPT_DOCUMENT,
        payload: { id, dockId, file },
    };
};

export const getApptDocument = (id) => {
    return {
        type: GET_APPT_DOCUMENT,
        payload: { id },
    };
};

export const deleteApptDocument = (apptId, id) => {
    return {
        type: DELETE_APPT_DOCUMENT,
        payload: { apptId, id },
    };
};

/** End */

export const refreshErrors = (id) => {
    return {
        type: REFRESH_ERRORS,
        payload: { id },
    };
};

export const addEditApptNote = (id, body) => {
    return {
        type: ADD_EDIT_APPT_NOTE,
        payload: { id, body },
    };
};

export const deleteApptNote = (apptId, noteId, type) => {
    return {
        type: DELETE_APPT_NOTE,
        payload: { apptId, noteId, type },
    };
};

export const requestApptNote = (apptId, message, single) => {
    return {
        type: REQUEST_APPT_NOTE,
        payload: { apptId, message, single },
    };
};
export const remindApptNote = (apptId, body) => {
    return {
        type: REMIND_APPT_NOTE,
        payload: { apptId, body },
    };
};

export const remindApptSignature = (body, apptId) => {
    return {
        type: REMIND_APPT_SIGNATURE,
        payload: { body, apptId },
    };
};

/** Eligibility */
export const checkEligibility = (id, apptId) => {
    return {
        type: CHECK_ELIGIBILITY,
        payload: { id, apptId },
    };
};
